import React from "react"

import { useTranslation } from "react-i18next"

import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined"
import { Grid } from "@mui/material"
import { Button, Typography } from "@synapse-analytics/synapse-ui"

interface Props {
  onRefetch?: () => Promise<unknown>
  isFetching?: boolean
}

/**
 * General component to display error message when fetching given query, and refetch action
 * to re-try fetching the requested query
 * @param {function} onRefetch action for refetching
 * @param {boolean} isFetching indicator if query is being fetched
 * @returns {React.ReactElement}
 */
export function ErrorStateWithRefetch(props: Readonly<Props>): React.ReactElement {
  const { onRefetch, isFetching } = props

  const { t } = useTranslation("UI")

  return (
    <Grid container gap={1} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
      <Typography variant="h3-bold">{t("ErrorStateWithRefetch.title")}</Typography>

      <Typography variant="p" align="center">
        {t("ErrorStateWithRefetch.description")}
      </Typography>

      <Button
        startIcon={<ReplayOutlinedIcon fontSize="small" />}
        disabled={isFetching}
        variant="primary"
        onClick={async () => await onRefetch?.()}
      >
        {t("ErrorStateWithRefetch.buttonText")}
      </Button>
    </Grid>
  )
}
